import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const MissionReportPage_Report_Foapu_Mutation = graphql(`
  mutation MissionReportPage_Report_Foapu(
    $filter: IdFilterInput!
    $update: ReportPartialInput!
    $versionData: VersionDataInput
  ) {
    findOneAndPartialUpdateReport(
      filter: $filter
      update: $update
      versionData: $versionData
    ) {
      _id
    }
  }
`);

export type MissionReport_Foapu_Result = ResultOf<
  typeof MissionReportPage_Report_Foapu_Mutation
>;

export const useFoapuMissionReportMutation = () =>
  useGraphQLMutation(MissionReportPage_Report_Foapu_Mutation);
